import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { serviceAPIMapping } from "../../../config/service-api-mapping";
import { constants, EndPoint, messages } from "../../../common/constants";
import _ from "lodash";
import { Alert, getDivHeight, mapRowId } from "../../../common/commonFunctions";
import { Snackbar } from "@mui/material";
import CPTYLimitsGrid from "../../../components/CPTYLimitsGrid";
import PNLBySecGrid from "../../../components/PNLBySecGrid";
import PieChart from "../../../components/PieChart";
import SingleCardKPI from "../../../components/SingleCardKPI";
import excel from "../../../assets/images/excel.svg";
import RefreshIcon from "@mui/icons-material/Refresh";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { isServiceHealthy } from "../../../utils/API";

const EODSummary = () => {
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [kpi, setKpi] = useState<any>([]);
  const [cptyBalance, setCptyBalance] = useState<any>([]);
  const [pnlSecurity, setPnlSecurity] = useState<any>([]);
  //const channel = new BroadcastChannel(Key.broadcastChannel)
  const [borrowBalByCPTY, setBorrowBalByCPTY] = useState<any>({
    labels: [],
    values: [],
    legendPosition: "bottom",
  });
  const [loanBalByCPTY, setLoanBalByCPTY] = useState<any>([]);
  const [borrowBalByTicker, setBorrowBalByTicker] = useState<any>({
    labels: [],
    values: [],
  });
  const [pnlByTicker, setPnlByTicker] = useState<any>({
    labels: [],
    values: [],
  });

  const accountId = window.localStorage.getItem("activeAccountCode");
  const accessToken = window.localStorage.getItem("refreshtoken");
  const [lastRefresh, setLastRefresh] = useState<any>("");
  const [cptyLimitGridApi, setCptyLimitGridApi] = useState<any>(null)
  const [pnlLimitGridApi, setPNLApiGrid] = useState<any>(null)
  const [isSmallerDeviceRes, setIsSmallerDeviceRes] = useState<boolean>(
    window?.innerWidth < 992
  );

  const headers = {
    "Content-Type": "application/json",
  };
  axios.defaults.headers.common = { Authorization: `Bearer ${accessToken}` };

  const getKpi = async () => {
    try {
      const raw = JSON.stringify({
        function_code: "fn_rpt_getpnlsummarykpi",
        function_param: {
          cur_date: moment().format("YYYY-MM-DD"),
          account_id_in: accountId,
        },
      });
      await axios
        .post(
          `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
          raw,
          { headers: headers }
        )
        .then((response: any) => {
          if (!_.isUndefined(response) && response?.status === 200) {
            const mappedRows = mapRowId(response?.data);
            setKpi(mappedRows);
          } else if (response?.status === 401) {
            // logout(channel)
          } else {
            //   const error = getError(response)
            //   setApiExceptionHandler({ isError: true, error: error })
          }
        });
    } catch (err) {
      //setApiExceptionHandler({ isError: true, error: err })
      setKpi([]);
    }
  };

  const getPnlSecurity = async () => {
    try {
      const raw = JSON.stringify({
        function_code: "fn_rpt_getpnlbysecurity",
        function_param: {
          accountid_in: accountId,
          date_in: moment().format("YYYY-MM-DD"),
        },
      });
      await axios
        .post(
          `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
          raw,
          { headers: headers }
        )
        .then((response: any) => {
          if (!_.isUndefined(response) && response?.status === 200) {
            const mappedRows = mapRowId(response?.data);
            setPnlSecurity(mappedRows);
            const groupByTicker = _.groupBy(response?.data, "ticker");
            const borrowByTickerLabelValue: any[] = [];
            const pnlByTickerLabelValue: any = [];
            Object.entries(groupByTicker).map(([key, value]) => {
              value.map((item: any) => {
                item.borr_bal =
                  item.borr_bal && _.isNumber(item.borr_bal)
                    ? item.borr_bal
                    : 0;
                item.pnl = item.pnl && _.isNumber(item.pnl) ? item.pnl : 0;
              });
              const totalBorrowExposure = _.sumBy(value, "borr_bal");
              const totalPnl = _.sumBy(value, "pnl");
              borrowByTickerLabelValue.push({
                label: key,
                value: totalBorrowExposure ? totalBorrowExposure : 0,
              });
              pnlByTickerLabelValue.push({
                label: key,
                value: totalPnl ? totalPnl : 0,
              });
            });
            const top10BorrowByTicker = _.sortBy(
              borrowByTickerLabelValue,
              "value"
            )
              .reverse()
              .slice(0, 10);
            const top10PnlByTicker = _.sortBy(pnlByTickerLabelValue, "value")
              .reverse()
              .slice(0, 10);
            setBorrowBalByTicker({
              labels: _.map(top10BorrowByTicker, "label"),
              values: _.map(top10BorrowByTicker, "value"),
            });
            setPnlByTicker({
              labels: _.map(top10PnlByTicker, "label"),
              values: _.map(top10PnlByTicker, "value"),
            });
          } else if (response?.status === 401) {
            //logout(channel)
          } else {
            // const error = getError(response)
            // setApiExceptionHandler({ isError: true, error: error })
          }
        });
    } catch (err) {
      //setApiExceptionHandler({ isError: true, error: err })
      setPnlSecurity([]);
    }
  };

  const getCptyBalance = async () => {
    try {
      const raw = JSON.stringify({
        function_code: "fn_rpt_getcptybalances",
        function_param: {
          accountid_in: accountId,
          date_in: moment().format("YYYY-MM-DD"),
        },
      });
      await axios
        .post(
          `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
          raw,
          { headers: headers }
        )
        .then((response: any) => {
          if (!_.isUndefined(response) && response?.status === 200) {
            const mappedRows = mapRowId(response?.data);
            const sortedRows = _.sortBy(mappedRows, "cpty_name");
            setCptyBalance(sortedRows);
            const groupByCptyId = _.groupBy(response?.data, "cpty_name");
            const borrowByCPTYLabelValue: any[] = [];
            const loanBalByCPTYLabelValue: any = [];
            Object.entries(groupByCptyId).map(([key, value]) => {
              value.map((item: any) => {
                item.borr_exposure =
                  item.borr_exposure && _.isNumber(item.borr_exposure)
                    ? item.borr_exposure
                    : 0;
                item.loan_exposure =
                  item.loan_exposure && _.isNumber(item.loan_exposure)
                    ? item.loan_exposure
                    : 0;
              });
              const totalBorrowExposure = _.sumBy(value, "borr_exposure");
              const totalLoanExposure = _.sumBy(value, "loan_exposure");
              borrowByCPTYLabelValue.push({
                label: key,
                value: totalBorrowExposure ? totalBorrowExposure : 0,
              });
              loanBalByCPTYLabelValue.push({
                label: key,
                value: totalLoanExposure ? totalLoanExposure : 0,
              });
            });
            const top10BorrowByCPTY = _.sortBy(borrowByCPTYLabelValue, "value")
              .reverse()
              .slice(0, 10);
            const top10LoanByCPTY = _.sortBy(loanBalByCPTYLabelValue, "value")
              .reverse()
              .slice(0, 10);
            setBorrowBalByCPTY({
              labels: _.map(top10BorrowByCPTY, "label"),
              values: _.map(top10BorrowByCPTY, "value"),
              legendPosition: "bottom",
            });
            setLoanBalByCPTY({
              labels: _.map(top10LoanByCPTY, "label"),
              values: _.map(top10LoanByCPTY, "value"),
              legendPosition: "bottom",
            });
          } else if (response?.status === 401) {
            //logout(channel)
          } else {
            //   const error = getError(response)
            //   setApiExceptionHandler({ isError: true, error: error })
          }
        });
    } catch (err) {
      // setApiExceptionHandler({ isError: true, error: err })
      setCptyBalance([]);
    }
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setIsSnackBarOpen(false);
  };

  useEffect(() => {
    getReportingServiceHealthCheck()
  }, []);

  const getReportingServiceHealthCheck = async () => {
      await isServiceHealthy(`${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}/${EndPoint.actuator}`).then((response: any)=>{
         if(!response?.ok || response?.status === 503){
          setSnackbarMessage(`Reporting${messages.serviceDownMessage}`)
          setIsSnackBarOpen(true)
       } else{
          refreshAccount()
       }
      })
    }
    
  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      cptyLimitGridApi?.current?.api?.getSheetDataForExcel?.({
        sheetName: "CPTY Limits Vs Exposure",
      })!,
      pnlLimitGridApi?.current?.api?.getSheetDataForExcel?.({
        sheetName: "PNL by Security",
      })!
     
    );
    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "eod-dashboard.xlsx",
    });
  }

  const refreshAccount = () => {
    setLastRefresh(moment(new Date()).format(constants.RefreshFormat));
    getKpi();
    getPnlSecurity();
    getCptyBalance();
  };

  useEffect(()=>{
    const returnInterval = setInterval(() => {
      getKpi();
    }, 15000);
    return () => clearInterval(returnInterval);
  },[])

  useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      setIsSmallerDeviceRes(window.innerWidth <= 992);
    }

    // Add the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ height: "95.5%", width: "99.8%" }}>
      <div className="row p-0 mx-auto w-100 d-flex align-items-center">
        <div
          className="col mx-auto title-subHeaderTitle dtc-title"
          style={{ height: "1.5rem" , paddingTop:isSmallerDeviceRes?'4px':'', whiteSpace:'nowrap'}}
        >
          EOD Summary Dashboard
        </div>
        <div className="col p-0 my-1 mx-auto">
          <div className="col p-0 mx-auto d-flex justify-content-end">
            <div
              className="borrowExceldnld"
              onClick={onExcelExport}
              title="Download Excel"
            >
              <img
                src={excel}
                alt=""
                style={{
                  height: "1.8rem",
                  width: "1.8rem",
                  cursor: "pointer",
                }}
              />
            </div>
            <div
              onClick={refreshAccount}
              title="Refresh Data"
              className="refresh-dtc"
            >
              <RefreshIcon
                style={{
                  color: "#1E355E",
                  marginRight: "0.5rem",
                  height: "1.6rem",
                  width: "1.6rem",
                  cursor: "pointer",
                }}
              />
              <div className="refreshsettimedateContract">
                <div>Last updated on: </div>
                <div style={{ whiteSpace: "nowrap" }}>{lastRefresh}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="eod-kpis">
        <SingleCardKPI kpiInfo={kpi} />
      </div>
      <Snackbar open={isSnackBarOpen} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "orange",
            textDecorationColor: "white",
          }}
        >
          <div>{snackbarMessage}</div>
        </Alert>
      </Snackbar>
      <div
        className="row p-0 mx-1 mt-1 pe-1 mx-auto"
        style={{ height: getDivHeight("eod-kpis",5) }}
      >
        <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-12 col-sm-12 p-0 d-flex flex-column ">
          <div
            style={{ height: isSmallerDeviceRes ? "40vh" : "50%" }}
            className="w-100 no-border-grid"
          >
            <CPTYLimitsGrid isEODDashboard={true} rowData={cptyBalance} getBtnRef={(gridApi: any) => {
                  setCptyLimitGridApi(gridApi);
                }}/>
          </div>
          <div
            style={{ height: isSmallerDeviceRes ? "40vh" : "50%" }}
            className="mt-1 w-100 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 no-border-grid"
          >
            <PNLBySecGrid isEODDashboard={true} rowData={pnlSecurity} getBtnRef={(gridApi: any) => {
                  setPNLApiGrid(gridApi);
                }}/>
          </div>
        </div>
        <div
          className="col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 p-0 ms-1 row"
          style={{ marginTop: isSmallerDeviceRes ? "0px" : "" }}
        >
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 p-0 d-flex flex-column">
            <div
              className="w-100"
              style={{
                height: isSmallerDeviceRes ? "50vh" : "50%",
                marginTop: isSmallerDeviceRes ? "4px" : "",
              }}
            >
              <PieChart
                title="Borrow Balance by CPTY"
                chartInfo={borrowBalByCPTY}
              />
            </div>
            <div
              className="mt-1 w-100"
              style={{ height: isSmallerDeviceRes ? "50vh" : "50%" }}
            >
              <PieChart
                title="Balance by Security"
                chartInfo={borrowBalByTicker}
              />
            </div>
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 p-0 d-flex flex-column">
            <div
              className="w-100 ms-1"
              style={{
                marginTop: isSmallerDeviceRes ? "4px" : "",
                height: isSmallerDeviceRes ? "50vh" : "50%",
              }}
            >
              <PieChart
                title="Loan Balance by CPTY"
                chartInfo={loanBalByCPTY}
              />
            </div>
            <div
              className="mt-1 w-100 ms-1"
              style={{ height: isSmallerDeviceRes ? "60vh" : "50%" }}
            >
              <PieChart title="PNL by Security" chartInfo={pnlByTicker} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EODSummary;
